<template>
  <v-container fluid class="pricelist-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-pricelist`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document</v-icon>
            Price List
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-prices`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Prices
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-discounts`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Discounts
          </v-tab>
          <v-tab-item
            :value="'tab-pricelist'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Price List</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePriceList($event, 'pricelistcode')"
                        v-bind:value="initvalue.pricelistcode"
                        placeholder="PriceList Code"
                        persistent-hint
                        single-line hint="Enter the pricelist code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePriceList($event, 'pricelistname')"
                        v-bind:value="initvalue.pricelistname"
                        placeholder="PriceList Name"
                        persistent-hint
                        single-line hint="Enter the pricelist name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Active', 'Inactive']"
                        :value="initvalue.priceliststatus"
                        outlined
                        dense
                        v-on:change="onChangePriceList($event, 'priceliststatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=pricelisttype
                        :value="initvalue.pricelisttype"
                        outlined
                        dense
                        v-on:change="onChangePriceList($event, 'pricelisttype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the pricelist type">
                      </v-select>
                      <v-select
                          class="mb-4"
                          :items="[{text: 'None', value: null}, ...saleschannels.map(x => {return {text: x.channelname, value: x._id};})]"
                          :value="initvalue.channelid"
                          v-on:change="onChangePriceList($event, 'channelid')"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the channel">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="[{text: 'None', value: null}, ...locations.map(x => {return {text: x.locationname, value: x._id};})]"
                          :value="initvalue.locationid"
                          v-on:change="onChangePriceList($event, 'locationid')"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/pricelist/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPriceList()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-prices'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Prices</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddPrice = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          to="/pricelist/list"
                          class="button-shadow mr-1"
                          color="success"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="pricerank"
                        :headers="header_prices"
                        :items="data_prices"
                        :items-per-page="500"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeletePrice" width="500">
                            <v-card>
                              <v-card-title> Delete this Price? </v-card-title>
                              <v-card-text>
                                {{ delete_price.pricename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeletePrice = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deletePrice(delete_price)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemid="{ item }">
                          {{ items.length!==0 ? items.find(i=>i._id == item.itemid)['itemname'] : ''  }}
                        </template>                    
                        <template v-slot:item.pricename="{ item }">
                          <p class="two-line">{{ item.pricename }}</p>
                          <p class="two-line">{{ item.pricecode }}</p>
                        </template>
                        <template v-slot:item.minqty="{ item }">
                          <p class="two-line">{{ item.minqty }} - {{ item.maxqty  }}</p>
                        </template>
                        <template v-slot:item.foc="{ item }">
                          <div v-if="item.foc!=null && item.foc.enable==true">
                            <p v-if="item.foc.itemqty && item.foc.getitemqty" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Buy:</span> {{ item.foc.itemqty }} x {{ items.length!==0 ? items.find(i=>i._id == item.itemid)['itemname'] : ''  }}</p>
                            <p v-if="item.foc.itemid" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Get:</span> {{ item.foc.getitemqty !=null ? item.foc.getitemqty.toFixed(4) : 0 }} x {{ items.length!==0 ? items.find(i=>i._id == item.foc.itemid)['itemname'] : ''  }}</p>
                            <p v-if="item.foc.itemsubcategoryid!=null" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Get Group:</span> {{ itemsubcategories.length!==0 && itemsubcategories.find(i=>i._id == item.foc.itemsubcategoryid)!=null ? itemsubcategories.find(i=>i._id == item.foc.itemsubcategoryid)['itemsubcategoryname'] : ''  }}</p>
                          </div>
                        </template>    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-tooltip bottom>
                            <template #activator="{ on }">
                              <v-btn 
                                icon 
                                v-on="on"
                                color="primary"
                                @click="editPriceFocDialog(item)"
                              >
                                <v-icon>mdi-playlist-edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit FOC</span>
                          </v-tooltip>
                          <v-btn
                            icon
                            color="primary"
                            @click="editPriceDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deletePriceDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-discounts'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Discounts</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddDiscount = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          to="/pricelist/list"
                          class="button-shadow mr-1"
                          color="success"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="discountrank"
                        :headers="header_discounts"
                        :items="data_discounts"
                        :items-per-page="500"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteDiscount" width="500">
                            <v-card>
                              <v-card-title> Delete this Discount? </v-card-title>
                              <v-card-text>
                                {{ delete_discount.discountname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteDiscount = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteDiscount(delete_discount)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.brandid="{ item }">
                          {{ brands.length!==0 ? brands.find(i=>i._id == item.brandid)['brandname'] : ''  }}
                        </template>                    
                        <template v-slot:item.minAmount="{ item }">
                          <p class="two-line">{{ item.minAmount }} - {{ item.maxAmount  }}</p>
                        </template>
                        <template v-slot:item.discountvalue="{ item }">
                          <p class="two-line">{{ item.discounttype=='Rate' ? item.discountvalue*100 : item.discountvalue }} {{ item.discounttype=='Rate' ? '%' : ''  }}</p>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editDiscountDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteDiscountDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog
          v-model="isAddPrice"
          persistent
          width="800px"
          max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Price</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-form>
                  <v-row class="nogutters">
                    <v-col  cols="12" md="3">
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        placeholder="Num"
                        persistent-hint
                        single-line hint="Num"
                        v-model="add_price.pricerank"
                        v-bind:error="errorindex == 21"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col  cols="12" md="9">
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Price Name"
                        persistent-hint
                        single-line hint="Enter the price name"
                        v-model="add_price.pricename"
                        v-bind:error="errorindex == 21"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-select
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Item"
                    single-line hint="Please choose the item"
                    :items="items.filter(x=>x.itemtype=='Item').map(x => {return {text: x.itemname, value: x._id};})"
                    v-model="add_price.itemid"
                    v-bind:error="errorindex == 20">
                  </v-select>
                  <v-text-field
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Currency"
                    v-model="add_price.currency"
                    v-bind:error="errorindex == 22"
                    single-line hint="Enter the currency"
                  >
                  </v-text-field>
                  <v-select
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Unit"
                    single-line hint="Please choose the unit"
                    :items="['Ctn', 'Doz', 'Pak', 'Box', 'Bot', 'Can', 'Bag']"
                    v-model="add_price.unit"
                    v-bind:error="errorindex == 23"
                  >
                  </v-select>
                </v-form>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="Min Qty"
                  persistent-hint
                  single-line hint="Enter the min quantity"
                  v-model="add_price.minqty"
                  v-bind:error="errorindex == 24"
                >
                </v-text-field>
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="Max Qty"
                  persistent-hint
                  single-line hint="Enter the max quantity"
                  v-model="add_price.maxqty"
                  v-bind:error="errorindex == 25"
                >
                </v-text-field>
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="List Price"
                  persistent-hint
                  single-line hint="Enter the list price"
                  v-model="add_price.listprice"
                  v-bind:error="errorindex == 26"
                >
                </v-text-field>
                </v-col>
              </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddPrice = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addPriceRequest"
              >
                Save
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="isEditPrice"
          persistent
          width="800px"
          max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Price</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-form>
                  <v-row class="nogutters">
                    <v-col  cols="12" md="3">
                      <v-text-field
                        type="number"
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Num"
                        persistent-hint
                        single-line hint="Num"
                        v-on:change="onChangePrice($event, 'pricerank')"
                        v-model="edit_price.pricerank"
                        v-bind:error="errorindex == 21"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col  cols="12" md="9">
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Price Name"
                        persistent-hint
                        single-line hint="Enter the price name"
                        v-on:change="onChangePrice($event, 'pricename')"
                        v-model="edit_price.pricename"
                        v-bind:error="errorindex == 21"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-select
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Item"
                    single-line hint="Please choose the item"
                    :items="items.length>0 ? items.map(x => {
                        return {text: x.itemname, value: x._id};
                      }) : []"
                    v-on:change="onChangePrice($event, 'itemid')"
                    v-model="edit_price.itemid">
                  </v-select>
                  <v-text-field
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Price Name"
                    persistent-hint
                    single-line hint="Enter the price name"
                    v-on:change="onChangePrice($event, 'pricename')"
                    v-model="edit_price.pricename"
                  >
                  </v-text-field>
                  <v-text-field
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Currency"
                    v-on:change="onChangePrice($event, 'currency')"
                    v-model="edit_price.currency"
                    single-line hint="Enter the currency"
                  >
                  </v-text-field>
                  <v-select
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Unit"
                    single-line hint="Please choose the unit"
                    :items="['Ctn', 'Doz', 'Pak', 'Box', 'Bot', 'Can', 'Bag']"
                    v-on:change="onChangePrice($event, 'unit')"
                    v-model="edit_price.unit"
                  >
                  </v-select>
                </v-form>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="Min Qty"
                  persistent-hint
                  single-line hint="Enter the min quantity"
                  v-on:change="onChangePrice($event, 'minqty')"
                  v-model="edit_price.minqty"
                >
                </v-text-field>
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="Max Qty"
                  persistent-hint
                  single-line hint="Enter the max quantity"
                  v-on:change="onChangePrice($event, 'maxqty')"
                  v-model="edit_price.maxqty"
                >
                </v-text-field>
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="List Price"
                  persistent-hint
                  single-line hint="Enter the list price"
                  v-on:change="onChangePrice($event, 'listprice')"
                  v-model="edit_price.listprice"
                >
                </v-text-field>
                </v-col>
              </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isEditPrice = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="editPriceRequest"
              >
                Save
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="isEditFoc"
          persistent
          width="800px"
          max-width="800px"
        >
          <v-card>
          <v-card-title>
            <span class="text-h5">Edit Foc</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    outlined
                    dense
                    v-on:change="onChangeFoc($event, 'itemqty')"
                    v-bind:value="edit_foc.itemqty"
                    placeholder="Item Qty"
                    persistent-hint
                    single-line hint="Enter the purchase item quantity">
                  </v-text-field>
                  <v-text-field
                    class="mb-4"
                    type="number"
                    outlined
                    dense
                    v-on:change="onChangeFoc($event, 'getitemqty')"
                    v-bind:value="edit_foc.getitemqty"
                    placeholder="FOC Item Qty"
                    persistent-hint
                    single-line hint="Enter the FOC item quantity">
                  </v-text-field>
                  <v-switch
                    v-model="edit_foc.enable"
                    v-on:change="onChangeFoc($event, 'enable')"
                    v-bind:label="edit_foc.enable==true ? 'true' : 'false'"
                    :value="edit_foc.enable"
                    :true-value="true"
                    :false-value="false"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="6">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="['Item', 'Subcategory Item', null]"
                        :value="edit_foc.type"
                        outlined
                        dense
                        v-on:change="onChangeFoc($event, 'type')"
                        placeholder="FOC Item Type"
                        persistent-hint
                        single-line hint="Please choose the FOC Item Type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...items.map(x => {return {text: x.itemname, value: x._id}})
                        ]"
                        :value="edit_foc.itemid"
                        outlined
                        dense
                        v-on:change="onChangeFoc($event, 'itemid')"
                        placeholder="Item"
                        persistent-hint
                        single-line hint="Please choose the FOC item">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...itemsubcategories.map(x => {return {text: x.itemsubcategoryname, value: x._id}})
                        ]"
                        :value="edit_foc.itemsubcategoryid"
                        outlined
                        dense
                        v-on:change="onChangeFoc($event, 'itemsubcategoryid')"
                        placeholder="Item Subcategory"
                        persistent-hint
                        single-line hint="Please choose the FOC item subcategory">
                      </v-select>
                    </v-form>
                  </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditFoc = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editPriceFoc"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="isAddDiscount"
          persistent
          width="800px"
          max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Discount</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-form>
                  <v-row class="nogutters">
                    <v-col cols="12" md="3">
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        placeholder="Num"
                        persistent-hint
                        single-line hint="Num"
                        v-model="add_discount.discountrank"
                        v-bind:error="errorindex == 21"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col  cols="12" md="9">
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Brand"
                        single-line hint="Please choose the brand"
                        :items="brands.filter(x=>x.brandstatus=='Active' && x.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id};})"
                        v-model="add_discount.brandid"
                        v-bind:error="errorindex == 20">
                      </v-select>
                    </v-col>
                  </v-row>
                    <v-text-field
                      class="mb-4"
                      outlined
                      dense
                      placeholder="Discount Name"
                      persistent-hint
                      single-line hint="Enter the discount name"
                      v-model="add_discount.discountname"
                      v-bind:error="errorindex == 21"
                    >
                    </v-text-field>
                </v-form>
              </v-col>
              <v-col cols="12" md="6">
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <v-text-field
                      class="mb-3 pr-2"
                      type="number"
                      outlined
                      dense
                      placeholder="Min Amount"
                      persistent-hint
                      single-line hint="Enter the min amount"
                      v-model="add_discount.minAmount"
                      v-bind:error="errorindex == 24"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                      
                    <v-text-field
                      class="mb-3 pr-0"
                      type="number"
                      outlined
                      dense
                      placeholder="Max Amount"
                      persistent-hint
                      single-line hint="Enter the max amount"
                      v-model="add_discount.maxAmount"
                      v-bind:error="errorindex == 24"
                    >
                    </v-text-field>
                  </v-col>

                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <v-select
                      class="mb-4 pr-2"
                      :items="['Rate', 'Value']"
                      v-model="add_discount.discounttype"
                      v-bind:error="errorindex == 24"
                      outlined
                      dense
                      placeholder="Type"
                      persistent-hint
                      single-line
                      hint="Enter the discount type"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      class="mb-4 pr-0"
                      type="number"
                      outlined
                      dense
                      placeholder="Discount Value"
                      persistent-hint
                      single-line hint="Enter the discount value"
                      v-model="add_discount.discountvalue"
                      v-bind:error="errorindex == 25"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddDiscount = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addDiscountRequest"
              >
                Save
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="isEditDiscount"
          persistent
          width="800px"
          max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Discount</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-form>
                  <v-row class="nogutters">
                    <v-col cols="12" md="3">
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        placeholder="Num"
                        persistent-hint
                        single-line hint="Num"
                        v-model="edit_discount.discountrank"
                        v-on:change="onChangeDiscount($event, 'discountrank')"
                        v-bind:error="errorindex == 21"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col  cols="12" md="9">
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Brand"
                        single-line hint="Please choose the brand"
                        :items="brands.filter(x=>x.brandstatus=='Active' && x.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id};})"
                        v-model="edit_discount.brandid"
                        v-on:change="onChangeDiscount($event, 'brandid')"
                        v-bind:error="errorindex == 20">
                      </v-select>
                    </v-col>
                  </v-row>
                    <v-text-field
                      class="mb-4"
                      outlined
                      dense
                      placeholder="Discount Name"
                      persistent-hint
                      single-line hint="Enter the discount name"
                      v-model="edit_discount.discountname"
                      v-on:change="onChangeDiscount($event, 'discountname')"
                      v-bind:error="errorindex == 21"
                    >
                    </v-text-field>
                </v-form>
              </v-col>
              <v-col cols="12" md="6">
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <v-text-field
                      class="mb-3 pr-2"
                      type="number"
                      outlined
                      dense
                      placeholder="Min Amount"
                      persistent-hint
                      single-line hint="Enter the min amount"
                      v-model="edit_discount.minAmount"
                      v-on:change="onChangeDiscount($event, 'minAmount')"
                      v-bind:error="errorindex == 24"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                      
                    <v-text-field
                      class="mb-3 pr-0"
                      type="number"
                      outlined
                      dense
                      placeholder="Max Amount"
                      persistent-hint
                      single-line hint="Enter the max amount"
                      v-model="edit_discount.maxAmount"
                      v-on:change="onChangeDiscount($event, 'maxAmount')"
                      v-bind:error="errorindex == 24"
                    >
                    </v-text-field>
                  </v-col>

                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <v-select
                      class="mb-4 pr-2"
                      :items="['Rate', 'Value']"
                      v-model="edit_discount.discounttype"
                      v-on:change="onChangeDiscount($event, 'discounttype')"
                      v-bind:error="errorindex == 24"
                      outlined
                      dense
                      placeholder="Type"
                      persistent-hint
                      single-line
                      hint="Enter the discount type"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      class="mb-4 pr-0"
                      type="number"
                      outlined
                      dense
                      placeholder="Discount Value"
                      persistent-hint
                      single-line hint="Enter the discount value"
                      v-model="edit_discount.discountvalue"
                      v-on:change="onChangeDiscount($event, 'discountvalue')"
                      v-bind:error="errorindex == 25"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isEditDiscount = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="editDiscountRequest"
              >
                Save
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      header_prices: [
        { text: '#', value: 'pricerank', width: '2%' },
        { text: 'Name', value: 'pricename', width: '8%' },
        { text: 'Item', value: 'itemid', width: '18%' },
        { text: 'Min-Max', value: 'minqty', width: '10%' },
        { text: 'Price', value: 'listprice', width: '10%'},
        { text: 'Foc', value: 'foc' },
        { text: "Actions", value: "actions", sortable: false , width: "12%"},
      ],
      header_discounts: [
        { text: '#', value: 'discountrank', width: '2%' },
        { text: 'Brand', value: 'brandid', width: '8%' },
        { text: 'Name', value: 'discountname'},
        { text: 'Min-Max', value: 'minAmount', width: '15%' },
        { text: 'Discount', value: 'discountvalue', width: '15%' },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      pricelisttype: ['Sales', 'Purchasing', 'Online', 'Other'],
      isAddPrice: false,
      isAddDiscount: false,
      isEditPrice:false,
      isEditDiscount: false,
      isEditFoc:false,
      isDeletePrice: false,
      isDeleteDiscount: false,
      error: null,
      errorindex: null,
      initvalue: {},
      edit_pricelist: {},
      add_price: {},
      add_discount: {},
      edit_price: {},
      edit_discount: {},
      edit_foc: {},
      delete_price: {},
      delete_discount: {},
      change_price: {},
      change_discount: {},
      change_foc: {},
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      data_prices: [],
      data_discounts: [],
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('ItemCategory', ['itemcategories']),
    ...mapState('ItemSubcategory', ['itemsubcategories']),
    ...mapState('Location', ['locations']),
    ...mapState('PriceList', ['pricelists', 'isReceiving']),
    ...mapState('SalesChannel', ['saleschannels']),
  },
  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('ItemCategory', ['getItemCategoriesRequest']),
    ...mapActions('ItemSubcategory', ['getItemSubcategoriesRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('Price', ['deletePriceRequest', 'deletePriceDiscountRequest', 'insertPriceRequest', 'insertPriceDiscountRequest', 'updatePriceRequest', 'updatePriceDiscountRequest', 'updateFocRequest']),
    ...mapActions('PriceList', ['updatePriceListRequest','getPriceListsRequest']),
    async addPriceRequest() {
      this.isAddPrice = false;
      this.add_price.pricelistid = this.initvalue._id;
      let result = await this.insertPriceRequest(this.add_price);
      this.data_prices.push(result);
      this.add_price = {};
    },
    async addDiscountRequest() {
      this.isAddDiscount = false;
      this.add_discount.pricelistid = this.initvalue._id;
      let result = await this.insertPriceDiscountRequest(this.add_discount);
      this.data_discounts.push(result);
      this.add_discount = {};
    },
    async deletePrice(payload) {
      this.isDeletePrice = false;
      let response = await this.deletePriceRequest(payload);
      let index = this.data_prices.findIndex((trans) => trans._id == response._id);
      this.data_prices.splice(index, 1);
    },
    async deleteDiscount(payload) {
      this.isDeleteDiscount = false;
      let response = await this.deletePriceDiscountRequest(payload);
      let index = this.data_discounts.findIndex((trans) => trans._id == response._id);
      this.data_discounts.splice(index, 1);
    },
    
    deletePriceDialog(item) {
      this.isDeletePrice = true;
      this.delete_price = { _id: item._id, pricename: item.pricename };
    },
    deleteDiscountDialog(item) {
      this.isDeleteDiscount = true;
      this.delete_discount = { _id: item._id, discountname: item.discountname };
    },
    editPriceDialog(item) {
      this.edit_price = {};
      this.edit_price = Object.assign({}, item);
      this.change_price = {};
      this.isEditPrice = true;
    },
    editPriceFocDialog(item) {
      this.isEditFoc = true;
      this.edit_foc = {};
      this.change_foc = {};
      this.edit_foc = Object.assign({}, {_id: item._id}, item.foc);
    },
    editDiscountDialog(item) {
      this.edit_discount = {};
      this.edit_discount = Object.assign({}, item);
      this.change_discount = {};
      this.isEditDiscount = true;
    },
    editPriceList() {
      this.edit_pricelist._id = this.initvalue._id;
      this.updatePriceListRequest(this.edit_pricelist);
      this.getPriceListsRequest();
      router.push('/pricelist/list');
    },
    async editPriceRequest() {
      this.isEditPrice = false;
      this.change_price._id = this.edit_price._id;
      let response = await this.updatePriceRequest(this.change_price);
      let index = this.data_prices.findIndex((x) => x._id == response._id);
      this.data_prices.splice(index, 1, response);
      this.edit_price = {};
      this.change_price = {};
    },
    async editPriceFoc() {
      this.isEditFoc = false;
      this.change_foc._id = this.edit_foc._id;
      let response = await this.updateFocRequest(this.change_foc);
      let index = this.data_prices.findIndex((price) => price._id == response._id);
      this.data_prices.splice(index, 1, response);
      this.edit_foc = {};
      this.change_foc = {};
    },
    async editDiscountRequest() {
      this.isEditDiscount = false;
      this.change_discount._id = this.edit_discount._id;
      let response = await this.updatePriceDiscountRequest(this.change_discount);
      let index = this.data_discounts.findIndex((x) => x._id == response._id);
      this.data_discounts.splice(index, 1, response);
      this.edit_discount = {};
      this.change_discount = {};
    },
    onChangePriceList(value, field){
      this.edit_pricelist[field] = value;
    },
    onChangePrice(value, field){
      this.change_price[field] = value;
    },
    onChangeFoc(value, field){
      this.change_foc[field] = value;
    },
    onChangeDiscount(value, field){
      this.change_discount[field] = value;
    },
  },
  async created () {
    this.initvalue = this.$route.params;
    this.data_prices = Object.assign([], this.initvalue.prices);
    this.data_discounts = Object.assign([], this.initvalue.discounts);
    if(!this.initvalue._id) this.$router.push({ name: 'PricelistList' });
    
    if(this.brands.length == 0) await this.getBrandsRequest();
    if(this.items.length == 0) await this.getItemsRequest();
    if(this.itemcategories.length == 0) await this.getItemCategoriesRequest();
    if(this.itemsubcategories.length == 0) await this.getItemSubcategoriesRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.pricelists.length == 0) await this.getPriceListsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
